import { render, staticRenderFns } from "./Net.vue?vue&type=template&id=be38dbd0&scoped=true&"
import script from "./Net.vue?vue&type=script&lang=js&"
export * from "./Net.vue?vue&type=script&lang=js&"
import style0 from "./Net.vue?vue&type=style&index=0&id=be38dbd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be38dbd0",
  null
  
)

export default component.exports